import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-2754">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-2755">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-2756" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-2757">
        <div className="max-w-3xl mx-auto text-center" data-id="element-2758">
          <div className="flex justify-center mb-5" data-id="element-2759">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2760">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-2761" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-2762">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-2763">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-2764">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-2765" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-2766">
        {/* IMPORTANT WARNING */}
        <section data-id="element-2767">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-2768">
            <div className="flex items-start gap-4" data-id="element-2769">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-2770">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-2771" />
              </div>
              <div data-id="element-2772">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-2773">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-2774">
                  Estás A <span className="font-black text-white" data-id="element-2775">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-2776">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-2777">
          <div className="text-center mb-8" data-id="element-2778">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-2779">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2780" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-2781">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-2782">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2783">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2784">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2785" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2786">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-2787">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2788">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2789">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2790" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2791">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-2792">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2793">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2794">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2795" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2796">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-2797">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2798">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2799">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2800" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2801">
                <span className="font-bold text-white" data-id="element-2802">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-2803">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2804">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2805" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2806">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-2807">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-2808">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-2809">
            <div className="flex items-center gap-3 mb-8" data-id="element-2810">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2811">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2812" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-2813">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-2814">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-2815">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-2816">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2817">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-2818" />
                </div>
                <div data-id="element-2819">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2820">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2821">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-2822">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2823">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-2824" />
                </div>
                <div data-id="element-2825">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2826">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2827">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-2828">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2829">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-2830" />
                </div>
                <div data-id="element-2831">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2832">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2833">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-2834">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2835">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-2836" />
                </div>
                <div data-id="element-2837">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2838">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2839">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-2840">
          <div className="text-center mb-8" data-id="element-2841">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-2842">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2843" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-2844">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-2845">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2846">
              <div className="flex gap-1 mb-4" data-id="element-2847">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2848" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2849" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2850" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2851" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2852" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2853" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2854">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2855">
                <p className="font-bold text-white text-sm" data-id="element-2856">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-2857">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2858">
              <div className="flex gap-1 mb-4" data-id="element-2859">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2860" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2861" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2862" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2863" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2864" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2865" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2866">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2867">
                <p className="font-bold text-white text-sm" data-id="element-2868">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-2869">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2870">
              <div className="flex gap-1 mb-4" data-id="element-2871">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2872" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2873" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2874" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2875" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2876" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2877" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2878">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2879">
                <p className="font-bold text-white text-sm" data-id="element-2880">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-2881">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-2882">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-2883">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-2884" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-2885">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-2886" />
      <WhatsAppButton data-id="element-2887" />
    </div>;
}